var map = {
	"./ion-action-sheet.entry.js": [
		576,
		5
	],
	"./ion-alert.entry.js": [
		577,
		6
	],
	"./ion-app_8.entry.js": [
		578,
		7
	],
	"./ion-avatar_3.entry.js": [
		579,
		17
	],
	"./ion-back-button.entry.js": [
		580,
		18
	],
	"./ion-backdrop.entry.js": [
		581,
		43
	],
	"./ion-button_2.entry.js": [
		582,
		19
	],
	"./ion-card_5.entry.js": [
		583,
		20
	],
	"./ion-checkbox.entry.js": [
		584,
		21
	],
	"./ion-chip.entry.js": [
		585,
		22
	],
	"./ion-col_3.entry.js": [
		586,
		44
	],
	"./ion-datetime_3.entry.js": [
		587,
		10
	],
	"./ion-fab_3.entry.js": [
		588,
		23
	],
	"./ion-img.entry.js": [
		589,
		45
	],
	"./ion-infinite-scroll_2.entry.js": [
		590,
		46
	],
	"./ion-input.entry.js": [
		591,
		24
	],
	"./ion-item-option_3.entry.js": [
		592,
		25
	],
	"./ion-item_8.entry.js": [
		593,
		26
	],
	"./ion-loading.entry.js": [
		594,
		27
	],
	"./ion-menu_3.entry.js": [
		595,
		28
	],
	"./ion-modal.entry.js": [
		596,
		8
	],
	"./ion-nav_2.entry.js": [
		597,
		14
	],
	"./ion-popover.entry.js": [
		598,
		9
	],
	"./ion-progress-bar.entry.js": [
		599,
		29
	],
	"./ion-radio_2.entry.js": [
		600,
		30
	],
	"./ion-range.entry.js": [
		601,
		31
	],
	"./ion-refresher_2.entry.js": [
		602,
		11
	],
	"./ion-reorder_2.entry.js": [
		603,
		16
	],
	"./ion-ripple-effect.entry.js": [
		604,
		47
	],
	"./ion-route_4.entry.js": [
		605,
		32
	],
	"./ion-searchbar.entry.js": [
		606,
		33
	],
	"./ion-segment_2.entry.js": [
		607,
		34
	],
	"./ion-select_3.entry.js": [
		608,
		35
	],
	"./ion-slide_2.entry.js": [
		609,
		48
	],
	"./ion-spinner.entry.js": [
		610,
		13
	],
	"./ion-split-pane.entry.js": [
		611,
		49
	],
	"./ion-tab-bar_2.entry.js": [
		612,
		36
	],
	"./ion-tab_2.entry.js": [
		613,
		15
	],
	"./ion-text.entry.js": [
		614,
		37
	],
	"./ion-textarea.entry.js": [
		615,
		38
	],
	"./ion-toast.entry.js": [
		616,
		39
	],
	"./ion-toggle.entry.js": [
		617,
		12
	],
	"./ion-virtual-scroll.entry.js": [
		618,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 268;
module.exports = webpackAsyncContext;